import React from "react"
import {ConnectSpinner} from "../../../spinner"
import {LoadingCoverContainer} from "./components"

interface Cashmere25LoadingCoverProps {
    testId: string
    ariaValueText: string
    itemsRequestPending: boolean
    breadcrumbsEnabled: boolean
    isMerchandisedUrl: boolean
}

export const Cashmere25LoadingCover = ({
    testId,
    ariaValueText,
    itemsRequestPending,
    breadcrumbsEnabled,
    isMerchandisedUrl,
}: Cashmere25LoadingCoverProps) => {
    if (!itemsRequestPending) return null

    return (
        <LoadingCoverContainer
            data-testid="plp-loading-cover"
            breadcrumbsEnabled={breadcrumbsEnabled}
            isMerchandisedUrl={isMerchandisedUrl}
        >
            <ConnectSpinner testid={testId} ariaValueText={ariaValueText} />
        </LoadingCoverContainer>
    )
}

export default Cashmere25LoadingCover
